import type React from 'react';

/**
 * A click anywhere on a row opens it — except on the row's own controls, and
 * except clicks from a menu or dialog the row opened (React bubbles portal
 * events through the row, but the DOM node is not inside it).
 */
export function rowOpens(event: React.MouseEvent<HTMLElement>): boolean {
  const target = event.target as HTMLElement;
  if (!event.currentTarget.contains(target)) return false;
  return !target.closest('button, a, input, select, textarea, [role="menuitem"], [role="combobox"], [role="checkbox"]');
}
